import React from 'react'

import type { ImageCtaBlock as ImageCtaBlockProps } from '@/payload-types'
import type { Media as MediaType } from '@/payload-types'

import { cn } from '@/utilities/ui'
import { Media } from '@/components/Media'
import { CMSLink } from '@/components/Link'

export const ImageCtaBlock: React.FC<
  ImageCtaBlockProps & {
    id?: string
    blockName?: string
    blockType: 'imagecta'
    className?: string
  }
> = ({ image, link, className }) => {
  const imageEl = image ? (
    <Media
      resource={image as MediaType}
      imgClassName={cn('w-full h-auto object-cover object-contain')}
      alt={typeof image === 'object' && image?.alt ? image.alt : 'Image CTA'}
    />
  ) : (
    <div className="w-full h-64 bg-muted rounded" />
  )

  // If link is provided, wrap image in CMSLink
  if (link?.link?.url) {
    return (
      <section className={cn(className)} aria-label="Image CTA">
        <div className="container px-0">
          <CMSLink {...link.link} className="block hover:opacity-90 transition-opacity">
            {imageEl}
          </CMSLink>
        </div>
      </section>
    )
  }

  // Otherwise just render the image
  return (
    <section className={cn(className)} aria-label="Image">
      <div className="container px-0">{imageEl}</div>
    </section>
  )
}

export default ImageCtaBlock
